import { Field, ID, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
export class Scope {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('scp') })
  _id: string

  @Field(() => String)
  @Prop({ type: String, index: true })
  key: string

  @Field(() => String)
  @Prop({ type: String, index: true })
  value: string
}
